<template>
  <div>
    <template v-if="media.type === 'text'">
      <div class="mediaTextContent">
        <div v-html="media.content" />
      </div>
    </template>
    <template v-else-if="media.type === 'image'">
      <img :src="setSrcFromDodocServer(media.thumbs[2].path)" />
    </template>
    <template v-else-if="media.type === 'video'">
      <video
        :src="setMediaSrcFromOriginalProject(media)"
        :poster="
            setSrcFromDodocServer(
              media.thumbs[0].thumbsData[2].path
            )
          "
        controls
        preload="none"
      />
    </template>
    <template v-else-if="media.type === 'audio'">
      <audio :src="setMediaSrcFromOriginalProject(media)" controls preload="none" />
    </template>
  </div>
</template>
<script>
export default {
  props: {
    media: Object
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  watch: {},
  computed: {},
  methods: {
    setMediaSrcFromOriginalProject(media) {
      const path = media.slugProjectName + "/" + media.media_filename;
      return this.setSrcFromDodocServer(path);
    },
    setSrcFromDodocServer(path) {
      return this.$root.dodoc_url + path;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
